/*$Id$*/
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from 'app/utils/bind.component.service';
import { CommonService } from './common.service';

declare const initTMG;

@Injectable()
export class GoogleTagManagerService extends CommonService {

  private KEY_GTM_PATH = '/datapackcompanyinfo?action=googleTagManager';
  private localURL: string;

  constructor(
    public http: Http,
    public modalService: NgbModal,
    public bindComponent: BindComponentService) {

    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.KEY_GTM_PATH;

  }

  init(): void {
    this.convertResponse(this.httpGet(this.localURL)).subscribe((key) => {
      initTMG(window, document, 'script', 'dataLayer', key);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/google-tag-manager.service.ts